module.exports = __webpack_public_path__ + "img/bg-rewards-page.72cbb349.png";